import React from 'react'

import styles from './HostingFrameworks.scss'

import images1 from './img/WordPress.svg';
import images2 from './img/OpenCart.svg';
import images3 from './img/Magento.svg';
import images4 from './img/PrestaShop.svg';
import images5 from './img/Laravel.svg';
import images6 from './img/Joomla.svg';
import images7 from './img/Drupal.svg';
import {__t} from '../../../common/lang/text-resource';

export default function HostingFrameworks() {
	return (
	  <>
		  <section className={styles.software}>
			  <div>
				  <img src={images1} alt='WordPress'/>
				  <img src={images2} alt='OpenCart'/>
				  <img src={images3} alt='Magento'/>
				  <img src={images4} alt='PrestaShop'/>
				  <img src={images5} alt='Laravel'/>
				  <img src={images6} alt='Joomla!'/>
				  <img src={images7} alt='Drupal'/>
			  </div>
			  <p>{__t('инсталирайте-лесно-и-бързо-най-популярните-уеб-сиc72ea8')}</p>
		  </section>
	  </>
	)
}